export default __webpack_public_path__ + "068b696bd7d0166ce71a04ed1f5943f8.png";